import { gql } from "lib/apolloClient";

export const bulkAssignmentGradeRatingsMutation = gql`
  mutation bulkAssignmentGradeRatings(
    $ratings: [BulkAssignmentGradeRatingsInput!]
  ) {
    platform {
      bulkAssignmentGradeRatings(input: $ratings) {
        isSuccess
        warning
      }
    }
  }
`;

export const bulkUpsertOverallStudentRatingsMutation = gql`
  mutation bulkUpsertOverallStudentRatings(
    $input: [BulkUpsertOverallStudentRatingsInput!]
  ) {
    planner {
      bulkUpsertOverallStudentRatings(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateLearningGoalsEvaluationCriteriaMutation = gql`
  mutation createIBPYPElementRatings(
    $elementRatings: [IBPYPElementRatingInput!]
  ) {
    planner {
      createIBPYPElementRatings(input: $elementRatings) {
        id
      }
    }
  }
`;

export const deleteLearningGoalsEvaluationCriteriaByIdsMutation = gql`
  mutation deleteLearningGoalsEvaluationCriteriaByIds($ids: [ID!]!) {
    planner {
      deleteIBPYPElementRatingByIds(ids: $ids)
    }
  }
`;

export const bulkGradeLearningGoalsEvaluationCriteriaMutation = gql`
  mutation bulkGradeLearningGoalsRatings(
    $input: BulkGradeLearningGoalsRatingsInput!
  ) {
    planner {
      bulkGradeLearningGoalsRatings(input: $input) {
        isSuccess
        warning
      }
      __typename
    }
  }
`;

export const createGradebookRatingsMutation = gql`
  mutation createGradebookRatings($input: [IBPYPElementRatingInput!]) {
    planner {
      createIBPYPElementRatings(input: $input) {
        id
      }
    }
  }
`;

export const createElementRemarksMutation = gql`
  mutation createElementRemarks($input: [IBPYPElementRemarkInput!]) {
    planner {
      createElementRemarks(input: $input) {
        response {
          id
        }
      }
    }
  }
`;

export const deleteGradebookRatingByIdsMutation = gql`
  mutation deleteGradebookRatingByIds($ids: [ID!]!) {
    planner {
      deleteIBPYPElementRatingByIds(ids: $ids)
    }
  }
`;
